export const LANDING_PRELOAD_IMAGES = [
  {
    href: 'https://media.doctornow.co.kr/home_main_banner_sick_in_bed.webp',
    type: 'image/webp',
  },
  {
    href: 'https://media.doctornow.co.kr/home_main_banner_busy_office.webp',
    type: 'image/webp',
  },
  {
    href: 'https://media.doctornow.co.kr/home_main_banner_medicine_hand.webp',
    type: 'image/webp',
  },
  {
    href: 'https://media.doctornow.co.kr/home_main_banner_pediatric_clinic.webp',
    type: 'image/webp',
  },
  {
    href: 'https://file.doctornow.co.kr/landing/bottom_banner.png',
    type: 'image/png',
  },
] as const;
